var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpstox = function SvgUpstox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A298B",
    fillRule: "evenodd",
    d: "M19.336.666c-1.564 0-2.59.586-3.226 1.417V.861h-1.857v12.805h1.857V8.68c.684.88 1.71 1.417 3.226 1.417 2.59 0 4.594-1.906 4.594-4.643 0-2.786-2.004-4.79-4.594-4.79m-.196 7.77c-1.76 0-3.03-1.32-3.03-2.98 0-1.662 1.27-3.08 3.03-3.08s2.933 1.418 2.933 3.08c0 1.66-1.174 2.98-2.933 2.98M4.576 5.7c.293-.196.538-.391.782-.636.44-.44.831-.977 1.124-1.515v2.395c0 1.515.831 2.346 2.2 2.346 1.417 0 2.54-.88 2.54-2.346V.86h1.858v9.042h-1.857V8.779c-.293.44-1.173 1.32-2.835 1.32-2.492 0-3.812-1.565-3.812-3.764zM.471 6.726V4.918c1.075 0 2.15-.44 2.932-1.173q.586-.586.88-1.32A4.2 4.2 0 0 0 4.576.861h1.857c0 .782-.146 1.564-.44 2.248a5.7 5.7 0 0 1-1.27 1.906A6.1 6.1 0 0 1 .47 6.725",
    clipRule: "evenodd"
  })));
};
export { SvgUpstox as ReactComponent };
export default __webpack_public_path__ + "55969ed7fff7e1989924f042be713931.svg";